<template>
  <div>
    <b-modal
      ref="openSubModal"
      :ok-title="$t('geral.save')"
      :cancel-title="$t('geral.cancel')"
      scrollable
      size="lg"
      title="Configuração de pendências:"
    >
      <b-container v-for="(block, index) in blocks" :key="index">
        <b-form-group label="" label-for="fields">
          <b-row
            :style="styledContainer(block)"
            :class="[
              'div-name-fields',
              !isBlockExpanded(block.blockId)
                ? 'action-collect'
                : 'action-expand',
            ]"
          >
            <b-col
              v-for="field in block.fields"
              :key="field.id"
              sm="4"
              md="4"
              lg="4"
            >
              <span
                v-b-tooltip.hover
                class="field-name"
                :style="selecterColor()"
                :title="
                  field.valor == ''
                    ? field.nome
                    : `${field.nome} (${field.valor})`
                "
              >
                {{
                  field.valor == ""
                    ? field.nome
                    : `${field.nome} (${field.valor})`
                }}
              </span>
            </b-col>
          </b-row>

          <div :style="{ display: 'flex', justifyContent: 'space-between' }">
            <div :style="{ textAlign: 'left' }">
              <span style="color: whitesmoke">
                {{
                  `${$t(
                    "checklist.form.FieldsWithSamePendingConfiguration"
                  )}: ${block.fields.length}`
                }}
              </span>
            </div>

            <!-- <div :style="{ textAlign: 'right' }">
              <b-button
                v-if="block.fields.length > 3"
                @click="toggleCollapse(block.blockId)"
                size="sm"
              >
                {{ isBlockExpanded(block.blockId) ? "Ver menos" : "Ver mais" }}
              </b-button>
            </div> -->
          </div>
        </b-form-group>

        <b-row>
          <b-col>
            <b-form-group label="Gera pendência" label-for="geraAnomalia">
              <b-form-select
                id="geraAnomalia"
                class="select-boolean"
                :options="optionsAnomaly"
                v-model="block.geraAnomalia"
              />
            </b-form-group>
          </b-col>

          <b-col v-if="block.geraAnomalia != 1">
            <b-form-group label="Prioridade" label-for="pendencyPriority">
              <pendency-priority-dropdown
                id="pendencyPriority"
                class="select-boolean"
                :model.sync="block.pendencyPriority"
              />
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group
              label="Pendências únicas"
              label-for="pendencyUniqueOpened"
              v-if="block.geraAnomalia != 1"
            >
              <pendency-unique-opened-dropdown
                id="pendencyUniqueOpened"
                class="select-boolean"
                :model.sync="block.pendencyUniqueOpened"
              />
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group
              label="Notificar geração"
              label-for="pendencyGenerationNotify"
              v-if="block.geraAnomalia != 1"
            >
              <pendency-generation-notify-dropdown
                id="pendencyGenerationNotify"
                class="select-boolean"
                :model.sync="block.pendencyGenerationNotify"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group
              :label="$t('checklist.form.profilesPendencyApprover')"
              label-for="profilesPendencyApprover"
              v-if="block.geraAnomalia != 1"
            >
              <multiselect
                id="profilesPendencyApprover"
                class="select-field"
                v-model="block.profilesApprover"
                label="displayName"
                track-by="id"
                :placeholder="$t('checklist.form.profilesPendencyApprover')"
                :close-on-select="false"
                :showLabels="false"
                :multiple="true"
                :options="profiles"
              />
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group
              :label="$t('checklist.form.profilesPendencyViewer')"
              label-for="profilesPendencyViewer"
              v-if="block.geraAnomalia != 1"
            >
              <multiselect
                id="profilesPendencyViewer"
                class="select-field"
                v-model="block.profilesViewer"
                label="displayName"
                track-by="id"
                :placeholder="$t('checklist.form.profilesPendencyViewer')"
                :close-on-select="false"
                :showLabels="false"
                :multiple="true"
                :options="profiles"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <div v-if="block.geraAnomalia != 1">
          <pendency-due-date-crud :dueDate.sync="block.pendencyDueDate" />
        </div>

        <div
          :style="{
            backgroundColor: !isDarkMode() ? '#1e1e2f' : 'rgb(98,113,128)',
            height: '2px',
            margin: '35px 0px',
          }"
        ></div>
      </b-container>

      <template #modal-footer="{}">
        <div style="text-align: right; width: 100%">
          <b-button
            class="ml-2"
            variant="green"
            @click="updateSelectedFieldsV2()"
            style="margin-left: 5px"
          >
            {{ $t("geral.confirm") }}
          </b-button>

          <b-button class="ml-2" variant="danger" @click="onModalHide()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>

      <!-- <pre class="language-json"><code>{{ blocks }}</code></pre> -->
      <!-- <pre class="language-json"><code>{{ selectedFields  }}</code></pre> -->
      <!-- <pre class="language-json"><code>{{ optionsProfiles  }}</code></pre> -->
      <!-- <pre class="language-json"><code>{{ profiles  }}</code></pre> -->
    </b-modal>

    <base-dialog-confirm
      ref="confirm"
      @confirm="cancelSubModal"
      @cancel="show"
      :message="'Sair sem salvar?'"
      :title="'Salvar processo'"
    />
  </div>
</template>

<script>
import PendencyGenerationNotifyDropdown from "@/components_rms/checklist/pendency/PendencyGenerationNotifyDropdown.vue";
import PendencyPriorityDropdown from "@/components_rms/checklist/pendency/PendencyPriorityDropdown.vue";
import PendencyUniqueOpenedDropdown from "@/components_rms/checklist/pendency/PendencyUniqueOpenedDropdown.vue";
export default {
  name: "FormPendingSubModal",
  components: {
    PendencyGenerationNotifyDropdown,
    PendencyPriorityDropdown,
    PendencyUniqueOpenedDropdown,
    PendencyDueDateCrud: () =>
      import("@/components_rms/checklist/pendency/PendencyDueDateCrud.vue"),
    BaseDialogConfirm: () =>
      import("@/components_rms/base/BaseDialogConfirm.vue"),
  },
  props: {
    selectedFields: Array,
    optionsProfiles: Array,
    profiles: Array,
  },
  data() {
    return {
      isCollapsed: false,
      expandedBlocks: {},
      blocks: [],
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      optionsAnomaly: [
        { value: 1, text: this.$t("checklist.form.no") },
        { value: 2, text: this.$t("checklist.form.yes") },
      ],
    };
  },
  methods: {
    groupBlocks() {
      this.blocks = [];

      for (let i = 0; i < this.selectedFields.length; i++) {
        let actualField = this.selectedFields[i];

        let block = this.blocks.find((block) =>
          block.fields.some(
            (field) =>
              field.id === actualField.id &&
              field.valor === actualField.valor
          )
        );

        if (!block) {
          let blockId = this.blocks.length + 1;
          block = this.createBlock(blockId);

          block.geraAnomalia = actualField.geraAnomalia;
          block.pendencyPriority = actualField.pendencyPriority;
          block.pendencyUniqueOpened = actualField.pendencyUniqueOpened;
          block.pendencyGenerationNotify = actualField.pendencyGenerationNotify;
          block.profilesApprover = actualField.profilesApprover;
          block.profilesViewer = actualField.profilesViewer;
          block.pendencyDueDate = actualField.pendencyDueDate;

          block.fields.push(actualField);
          this.blocks.push(block);
        }

        for (let k = i + 1; k < this.selectedFields.length; k++) {
          let compareField = this.selectedFields[k];
          if (actualField.id === compareField.id) {
            continue;
          }
          if (
            actualField.pendencyPriority === compareField.pendencyPriority &&
            actualField.pendencyUniqueOpened ===
              compareField.pendencyUniqueOpened &&
            actualField.pendencyGenerationNotify ===
              compareField.pendencyGenerationNotify &&
            this.validadeProfiles(
              actualField.profilesApprover,
              compareField.profilesApprover
            ) &&
            this.validadeProfiles(
              actualField.profilesViewer,
              compareField.profilesViewer
            ) &&
            this.validadeDueDate(
              actualField.pendencyDueDate,
              compareField.pendencyDueDate
            )
          ) {
            let field = block.fields.find(
              (field) => field.id === compareField.id
            );
            if (!field) {
              block.fields.push(compareField);
            }
          }
        }
      }
    },
    createBlock(blockId) {
      return {
        blockId: blockId,
        expandedBlock: false,
        geraAnomalia: 2,
        pendencyPriority: 2,
        pendencyUniqueOpened: false,
        pendencyGenerationNotify: false,
        profilesApprover: [],
        profilesViewer: [],
        pendencyDueDate: {
          fieldId: null,
          formFieldOptionId: null,
          dueDateIntervalType: 0,
          dueDateIntervalRange: 0,
          formPendencyNotifies: [],
        },
        fields: [],
      };
    },
    updateSelectedFieldsV2() {
      this.blocks.forEach((block) => {
        block.fields.forEach((field) => {
          let fieldUpdate = this.selectedFields.filter(
            (selectedField) =>
              field.id === selectedField.id &&
              field.valor === selectedField.valor
          );

          if (block.geraAnomalia === 1) {
            fieldUpdate.forEach((update) => {
              update.geraAnomalia = block.geraAnomalia;
              update.pendencyPriority = 2;
              update.pendencyUniqueOpened = false;
              update.pendencyGenerationNotify = false;
              update.profilesApprover = [];
              update.profilesViewer = [];
              update.pendencyDueDate = {
                fieldId: null,
                formFieldOptionId: null,
                dueDateIntervalType: 0,
                dueDateIntervalRange: 0,
                formPendencyNotifies: [],
              };
            });
          } else if (block.geraAnomalia === 2) {
            fieldUpdate.forEach((update) => {
              update.geraAnomalia = block.geraAnomalia;
              update.pendencyPriority = block.pendencyPriority;
              update.pendencyUniqueOpened =
                block.pendencyUniqueOpened;
              update.pendencyGenerationNotify =
                block.pendencyGenerationNotify;
              update.profilesApprover = block.profilesApprover;
              update.profilesViewer = block.profilesViewer;
              update.pendencyDueDate = block.pendencyDueDate;
            });
          }
        });
      });
      this.cancelSubModal();
    },
    styledContainer(block) {
      let stringStyle = "";

      if (block.fields.length > 3) {
        stringStyle += "";
      } else stringStyle += "height: auto !important;";

      if (this.$store.state.darkmode) {
        stringStyle +=
          "border: 1px solid #2b3553 !important;background-color: #1e1e2f;";
      } else {
        stringStyle +=
          "border: 1px solid #2b3553 !important;background-color: whitesmoke;";
      }

      return stringStyle;
    },
    validadeProfiles(actualField, compareField) {
      if (!Array.isArray(actualField) || !Array.isArray(compareField))
        return false;

      if (actualField.length < 1 && compareField.length < 1) return true;

      if (actualField.length !== compareField.length) return false;

      for (let i = 0; i < actualField.length; i++) {
        const actualId = actualField[i].id;

        const compareFieldIds = compareField.map((field) => field.id);

        if (compareFieldIds.includes(actualId)) return true;
        else return false;
      }
    },
    validadeDueDate(actualField, compareField) {
      if (!actualField || !compareField) return false;

      if (
        actualField.dueDateIntervalType === 0 &&
        compareField.dueDateIntervalType === 0
      ) {
        return true;
      } else if (
        actualField.fieldId === compareField.fieldId &&
        actualField.formFieldOptionId === compareField.formFieldOptionId &&
        actualField.dueDateIntervalType === compareField.dueDateIntervalType &&
        actualField.dueDateIntervalRange === compareField.dueDateIntervalRange
      )
        return true;
      else return false;
    },
    showSubModal() {
      this.groupBlocks();
      this.$refs.openSubModal.show();
    },
    show() {
      this.$refs.openSubModal.show();
    },
    cancelSubModal() {
      this.$emit("close-modal");
      this.$refs.openSubModal.hide();
    },
    onModalHide() {
      let showModal = false;

      for (let i = 0; i < this.blocks.length; i++) {
        let block = this.blocks[i];
        if (block.geraAnomalia === 2) {
          showModal = true;
          break;
        }
      }

      if (showModal) this.$refs.confirm.show();
      else this.cancelSubModal();
    },
    isDarkMode() {
      return this.$store.state.darkmode;
    },
    selecterColor() {
      return this.$store.state.darkmode
        ? { color: "whitesmoke" }
        : { color: "#1E1E2F" };
    },
    toggleCollapse(blockId) {
      this.$set(this.expandedBlocks, blockId, !this.expandedBlocks[blockId]);
    },
    isBlockExpanded(blockId) {
      return !!this.expandedBlocks[blockId];
    },
  },
};
</script>

<style scoped>
.input-name {
  min-width: 200px;
}
.input-tip {
  min-width: 200px;
}
.select-boolean {
  min-width: 75px;
}
.select-field {
  min-width: 100px;
}
.table-responsive {
  overflow: visible !important;
}
.field-name {
  max-width: 220px;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.div-name-fields {
  display: flex; /* para que os elementos fiquem em linha */
  overflow: hidden; /* para que os elementos não ultrapassem o container */
  white-space: nowrap; /* para que os elementos não quebrem linha */
  width: 100%;
  padding: 10px;
  margin: 0px 0px 10px 0px;
  border-radius: 10px;
}
.action-collect {
  height: 150px;
  transition: height 0.5s ease;
  overflow-y: auto;
}

.action-expand {
  height: 200px;
  transition: height 0.5s ease;
  overflow-y: auto;
}
</style>
